"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5147],{

/***/ 71357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "Ui": function() { return /* binding */ mediaQueryHOC; },
/* harmony export */   "ag": function() { return /* binding */ useMatchMedia; },
/* harmony export */   "hZ": function() { return /* binding */ useScrollBlock; },
/* harmony export */   "y3": function() { return /* binding */ updateCurrentProductIndex; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91058);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // https://github.com/streamich/react-use/blob/master/docs/useIsomorphicLayoutEffect.md


var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_13__.useLayoutEffect : 0;
function useMatchMedia(mediaQueryString) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(initialValue),
      match = _useState[0],
      setMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    if (!window.matchMedia) {
      return;
    }

    function handleMatch(event) {
      setMatch(event.matches);
    }

    var matchMedia = window.matchMedia(mediaQueryString);
    setMatch(matchMedia.matches);
    matchMedia.addListener(handleMatch);
    return function () {
      matchMedia.removeListener(handleMatch);
    };
  }, [mediaQueryString]);
  return match;
}
var mediaQueryHOC = function mediaQueryHOC(Component) {
  function MediaQueryHOC(props) {
    var isXSmall = useMatchMedia('(max-width: 375px)');
    var isSmall = useMatchMedia('(max-width: 479px)');
    var isMedium = useMatchMedia('(max-width: 767px)');
    var isLarge = useMatchMedia('(max-width: 991px)');
    var isXLarge = useMatchMedia('(max-width: 1023px)');
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(Component, _objectSpread({
      isXSmall: isXSmall,
      isSmall: isSmall,
      isMedium: isMedium,
      isLarge: isLarge,
      isXLarge: isXLarge
    }, props));
  }

  return MediaQueryHOC;
};
var listeners = [];
var state = {
  currentProductIndex: 0
};

var setState = function setState(newState) {
  state = _objectSpread(_objectSpread({}, state), newState);
  listeners.forEach(function (listener) {
    listener(state);
  });
};

var updateCurrentProductIndex = function updateCurrentProductIndex() {
  var newListener = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)()[1];
  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};
var useScrollBlock = function useScrollBlock() {
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_13__.useRef)(false);

  var blockScroll = function blockScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document = document,
        body = _document.body;
    if (!(body == null ? void 0 : body.style) || scroll.current) return;
    var scrollBarWidth = window.innerWidth - html.clientWidth;
    var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue("padding-right")) || 0;
    Object.assign(html.style, {
      position: "relative",
      overflow: "hidden"
    });
    Object.assign(body.style, {
      position: "relative",
      overflow: "hidden",
      paddingRight: "".concat(bodyPaddingRight + scrollBarWidth, "px")
    });
    scroll.current = true;
  };

  var allowScroll = function allowScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document2 = document,
        body = _document2.body;
    if (!(body == null ? void 0 : body.style) || !scroll.current) return;
    Object.assign(html.style, {
      position: "",
      overflow: ""
    });
    Object.assign(body.style, {
      position: "",
      overflow: "",
      paddingRight: ""
    });
    scroll.current = false;
  };

  return [blockScroll, allowScroll];
};

/***/ }),

/***/ 55891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ scrollIntoView; }
/* harmony export */ });
var smoothScrollId = null;
var smoothScrollStartY = 0;
var smoothScrollDeltaY = 0;
var smoothScrollStartTime = 0;
var smoothScrollDuration = 400;
function scrollIntoView(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  smoothScrollStartY = window.scrollY || window.pageYOffset || 0;
  smoothScrollDeltaY = element.getBoundingClientRect().top;
  var headerElement = document.querySelector('.zone-header');
  var productSubNavElement = document.querySelector('.ob-product-sub-nav');

  if (headerElement) {
    smoothScrollDeltaY -= headerElement.getBoundingClientRect().bottom;

    if (productSubNavElement) {
      smoothScrollDeltaY -= productSubNavElement.getBoundingClientRect().bottom;
    }
  }

  if (options.behavior === 'smooth' && typeof requestAnimationFrame !== 'undefined') {
    smoothScrollStartTime = Date.now();

    if (smoothScrollId == null) {
      smoothScrollStep();
    }
  } else {
    if (smoothScrollId != null) {
      cancelAnimationFrame(smoothScrollId);
      smoothScrollId = null;
    }

    window.scrollTo(window.scrollX, null);
  }
}

function smoothScrollStep() {
  var elapsed = Date.now() - smoothScrollStartTime;
  var t = elapsed / smoothScrollDuration;

  if (t < 1) {
    smoothScrollId = requestAnimationFrame(smoothScrollStep);
    window.scrollTo(window.scrollX, easeInOutQuad(t) * smoothScrollDeltaY + smoothScrollStartY);
  } else {
    smoothScrollId = null;
    window.scrollTo(window.scrollX, smoothScrollDeltaY + smoothScrollStartY);
  }
}

function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : (4 - 2 * t) * t - 1;
}

/***/ }),

/***/ 19271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ optimizeImage; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__);


var optimizeImage = function optimizeImage(imageUrl, imageFormatValue, imageQualityValue) {
  var imageFormat = imageFormatValue ? imageFormatValue : 'webp';
  var imageQuality = imageQualityValue ? imageQualityValue : 85;

  if (imageUrl !== undefined && imageUrl !== null && imageUrl.includes('images.ctfassets.net') && imageUrl.includes('fm=webp') == false && imageUrl.includes('.svg') == false) {
    var _imageUrl;

    if ((_imageUrl = imageUrl) == null ? void 0 : _imageUrl.includes('https')) {
      var _imageUrl2;

      if ((_imageUrl2 = imageUrl) == null ? void 0 : _imageUrl2.includes('?')) {
        imageUrl = imageUrl + "&fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      } else {
        imageUrl = imageUrl + "?fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      }
    } else {
      var _imageUrl3;

      imageUrl = 'https:' + imageUrl;

      if ((_imageUrl3 = imageUrl) == null ? void 0 : _imageUrl3.includes('?')) {
        imageUrl = imageUrl + "&fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      } else {
        imageUrl = imageUrl + "?fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      }
    }
  }

  return imageUrl;
};

/***/ }),

/***/ 75147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7980);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43290);
/* harmony import */ var core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_fill_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(91038);
/* harmony import */ var core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_from_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(68309);
/* harmony import */ var core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name_js__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(46066);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(71357);
/* harmony import */ var _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(24036);
/* harmony import */ var _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(40483);
/* harmony import */ var _adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(8996);
/* harmony import */ var _adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(19271);
/* harmony import */ var _VideoPlayer_VideoPlayer__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(65509);
/* harmony import */ var _adapters_helpers_Scroll__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(55891);
/* harmony import */ var _VideoPlayer_VideoPlayerAudiDescription__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(13370);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(85893);









function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_7___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }























var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_21___default()(function () {
  return __webpack_require__.e(/* import() */ 8084).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});
var Icon = next_dynamic__WEBPACK_IMPORTED_MODULE_21___default()(function () {
  return __webpack_require__.e(/* import() */ 713).then(__webpack_require__.bind(__webpack_require__, 80713));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(80713)];
    }
  }
});

var YoutubeVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_21___default()(function () {
  return __webpack_require__.e(/* import() */ 6806).then(__webpack_require__.bind(__webpack_require__, 76806));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76806)];
    }
  }
});
var ResponsiveImage = next_dynamic__WEBPACK_IMPORTED_MODULE_21___default()(function () {
  return __webpack_require__.e(/* import() */ 8758).then(__webpack_require__.bind(__webpack_require__, 38758));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(38758)];
    }
  }
});






var SwitchTab = next_dynamic__WEBPACK_IMPORTED_MODULE_21___default()(function () {
  return __webpack_require__.e(/* import() */ 7311).then(__webpack_require__.bind(__webpack_require__, 17311));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(17311)];
    }
  }
});

var CarouselBlock = function CarouselBlock(props) {
  var _doc$fields, _doc$fields2, _doc$fields2$rightArr, _doc$fields2$rightArr2, _doc$fields2$rightArr3, _doc$fields3, _doc$fields3$leftArro, _doc$fields3$leftArro2, _doc$fields3$leftArro3, _doc$fields4, _doc$fields5, _doc$fields5$carousel, _doc$fields6, _doc$fields6$carousel, _doc$fields7, _doc$fields7$carousel, _doc$fields8, _doc$fields9, _doc$fields10, _doc$fields11, _doc$fields12, _doc$fields13, _doc$fields14, _doc$fields15, _doc$fields15$carouse, _doc$fields16, _doc$fields17, _doc$fields17$carouse, _doc$fields18, _doc$fields19, _doc$fields20, _doc$fields21, _doc$fields21$leftArr, _doc$fields21$leftArr2, _doc$fields21$leftArr3, _doc$fields22, _doc$fields22$leftArr, _doc$fields22$leftArr2, _doc$fields22$leftArr3, _doc$fields23, _doc$fields24, _doc$fields25, _doc$fields25$rightAr, _doc$fields25$rightAr2, _doc$fields25$rightAr3, _doc$fields26, _doc$fields26$rightAr, _doc$fields26$rightAr2, _doc$fields26$rightAr3, _doc$fields27, _doc$fields28, _doc$fields28$carouse, _doc$fields32, _doc$fields33, _doc$fields33$carouse, _doc$fields33$carouse2, _doc$fields34, _doc$fields34$carouse, _doc$fields34$carouse2, _doc$fields35, _doc$fields35$carouse, _doc$fields35$carouse2, _doc$fields36, _doc$fields37, _doc$fields38;

  var doc = props.document,
      isMedium = props.isMedium,
      isSmall = props.isSmall,
      isXSmall = props.isXSmall;
  var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_20__.useRef)(null);
  var carouselRef = (0,react__WEBPACK_IMPORTED_MODULE_20__.useRef)();

  var videoSettings = _objectSpread(_objectSpread({}, doc == null ? void 0 : (_doc$fields = doc.fields) == null ? void 0 : _doc$fields.carouselSettings), {}, {
    nextArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("img", {
      tabIndex: 0,
      src: (0,_adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_29__/* .optimizeImage */ .H)(doc == null ? void 0 : (_doc$fields2 = doc.fields) == null ? void 0 : (_doc$fields2$rightArr = _doc$fields2.rightArrowIcon) == null ? void 0 : (_doc$fields2$rightArr2 = _doc$fields2$rightArr.fields) == null ? void 0 : (_doc$fields2$rightArr3 = _doc$fields2$rightArr2.file) == null ? void 0 : _doc$fields2$rightArr3.url),
      "data-action-detail": "carousel_panel",
      alt: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.rightArrow */ .NM.rightArrow
    }),
    prevArrow: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("img", {
      tabIndex: 0,
      src: (0,_adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_29__/* .optimizeImage */ .H)(doc == null ? void 0 : (_doc$fields3 = doc.fields) == null ? void 0 : (_doc$fields3$leftArro = _doc$fields3.leftArrowIcon) == null ? void 0 : (_doc$fields3$leftArro2 = _doc$fields3$leftArro.fields) == null ? void 0 : (_doc$fields3$leftArro3 = _doc$fields3$leftArro2.file) == null ? void 0 : _doc$fields3$leftArro3.url),
      "data-action-detail": "carousel_panel",
      alt: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.leftArrow */ .NM.leftArrow
    })
  });

  var anchorId = doc == null ? void 0 : (_doc$fields4 = doc.fields) == null ? void 0 : _doc$fields4.anchorId;

  var handleGAClassName = function handleGAClassName(ele) {
    if (ele && ele.length > 0) {
      for (var i = 0; i < ele.length; i++) {
        ele[i].classList.add('event_button_click');
      }
    }
  };

  var handleClickTab = function handleClickTab(index) {
    sliderRef.current.slickGoTo(index);
  };

  var handleClickPageTab = function handleClickPageTab(index) {
    sliderRef.current.slickGoTo(index);
    setCurrentSlideIndex(index);
    setActiveTabIndex(index);
    var sliderElement = document.querySelector('.slick-slider');
    var sliderPosition = sliderElement.getBoundingClientRect().top + window.scrollY;
    var offset = 200;
    var mobileOffset = 70;
    isSmall || isXSmall ? window.scrollTo({
      top: sliderPosition - mobileOffset,
      behavior: 'smooth'
    }) : window.scrollTo({
      top: sliderPosition - offset,
      behavior: 'smooth'
    });
    var timeout = setTimeout(function () {
      var tabElement = document.querySelector('.carousel-tab-page.active');
      var parent = tabElement == null ? void 0 : tabElement.parentElement;
      parent.scrollLeft = (tabElement == null ? void 0 : tabElement.offsetLeft) - (parent == null ? void 0 : parent.offsetWidth) / 2 + (tabElement == null ? void 0 : tabElement.offsetWidth) / 2;
    }, 1000);
    return function () {
      return clearTimeout(timeout);
    };
  };

  var handleClickPageTabsScroll = function handleClickPageTabsScroll(index) {
    sliderRef.current.slickGoTo(index);
    setCurrentSlideIndex(index);
    setActiveTabIndex(index);
    setTimeout(function () {
      var tabElement = document.querySelector('.carousel-tab-page.active');
      var parent = tabElement == null ? void 0 : tabElement.parentElement;
      var scrollOptions = {
        left: (tabElement == null ? void 0 : tabElement.offsetLeft) - (parent == null ? void 0 : parent.offsetWidth) / 2 + (tabElement == null ? void 0 : tabElement.offsetWidth) / 2,
        behavior: 'smooth'
      };
      parent.scrollTo(scrollOptions);
    }, 1000);
  };

  (0,react__WEBPACK_IMPORTED_MODULE_20__.useEffect)(function () {
    var _window, _window$location;

    handleGAClassName(document.getElementsByClassName('slick-prev'));
    handleGAClassName(document.getElementsByClassName('slick-next'));
    setTimeout(function () {
      var _document;

      var videoButtonId = (_document = document) == null ? void 0 : _document.getElementById('button-video');
      videoButtonId == null ? void 0 : videoButtonId.addEventListener('click', function () {
        return setIsModalOpen(true);
      });
    }, 3000);

    if (((_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.hash) === "#".concat(anchorId) && (carouselRef == null ? void 0 : carouselRef.current)) {
      var timeout = null;
      window.setTimeout(function () {
        timeout = (0,_adapters_helpers_Scroll__WEBPACK_IMPORTED_MODULE_34__/* .scrollIntoView */ .z)(carouselRef.current, {
          behavior: 'smooth',
          block: 'nearest'
        });
      }, 250);
      return function () {
        clearTimeout(timeout);
      };
    }
  }, []);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_20__.useState)(Array(doc == null ? void 0 : (_doc$fields5 = doc.fields) == null ? void 0 : (_doc$fields5$carousel = _doc$fields5.carouselItems) == null ? void 0 : _doc$fields5$carousel.length).fill(0)),
      selectedVariants = _useState[0],
      setSelectedVariants = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_20__.useState)(0),
      activeTabIndex = _useState2[0],
      setActiveTabIndex = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_20__.useState)(0),
      currentSlideIndex = _useState3[0],
      setCurrentSlideIndex = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_20__.useState)(false),
      isModalOpen = _useState4[0],
      setIsModalOpen = _useState4[1];

  var hideAriaHiddenTiles = function hideAriaHiddenTiles() {
    Array.from(document.querySelectorAll('.slick-slide')).forEach(function (slide) {
      slide.setAttribute('aria-hidden', false);
    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_20__.useEffect)(function () {
    hideAriaHiddenTiles();
  });
  var tabItems = doc == null ? void 0 : (_doc$fields6 = doc.fields) == null ? void 0 : (_doc$fields6$carousel = _doc$fields6.carouselItems) == null ? void 0 : _doc$fields6$carousel.map(function (item, index) {
    var _item$fields, _item$fields2;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
      tabIndex: 0,
      role: "button",
      className: "carousel-tab ".concat(index === activeTabIndex ? 'active' : '', " event_button_click"),
      "data-action-detail": item == null ? void 0 : (_item$fields = item.fields) == null ? void 0 : _item$fields.tabTitle,
      onClick: function onClick() {
        return handleClickTab(index);
      },
      onKeyPress: function onKeyPress() {
        return handleClickTab(index);
      },
      children: item == null ? void 0 : (_item$fields2 = item.fields) == null ? void 0 : _item$fields2.tabTitle
    }, index);
  });
  var tabPageItems = doc == null ? void 0 : (_doc$fields7 = doc.fields) == null ? void 0 : (_doc$fields7$carousel = _doc$fields7.carouselItems) == null ? void 0 : _doc$fields7$carousel.map(function (item, index) {
    var _item$fields3, _item$fields3$tabHtml, _item$fields3$tabHtml2, _item$fields4, _item$fields4$tabHtml, _item$fields4$tabHtml2;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
      className: "carousel-tab-page ".concat(index === activeTabIndex ? 'active' : ''),
      onClick: function onClick() {
        return handleClickPageTab(index);
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
        className: item == null ? void 0 : (_item$fields3 = item.fields) == null ? void 0 : (_item$fields3$tabHtml = _item$fields3.tabHtmlSection) == null ? void 0 : (_item$fields3$tabHtml2 = _item$fields3$tabHtml.fields) == null ? void 0 : _item$fields3$tabHtml2.classNames,
        dangerouslySetInnerHTML: {
          __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(item == null ? void 0 : (_item$fields4 = item.fields) == null ? void 0 : (_item$fields4$tabHtml = _item$fields4.tabHtmlSection) == null ? void 0 : (_item$fields4$tabHtml2 = _item$fields4$tabHtml.fields) == null ? void 0 : _item$fields4$tabHtml2.text)
        }
      })
    }, index);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_20__.useEffect)(function () {
    setActiveTabIndex(currentSlideIndex);
  }, [currentSlideIndex]);

  var closeModal = function closeModal() {
    setIsModalOpen(false);
  };

  var openModal = function openModal(event) {
    event.preventDefault();
    setIsModalOpen(true);
  };

  var customStyles = {
    overlay: {
      position: 'fixed',
      top: '0px',
      left: '0px',
      right: '0px',
      bottom: '0px',
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    content: {
      border: 'none',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      padding: '0',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '100rem',
      width: '90%'
    }
  };

  var renderVideo = function renderVideo(video) {
    return (video == null ? void 0 : video.videoId) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(YoutubeVideo, {
      document: video
    }) : (video == null ? void 0 : video.isAudioDescriptionVideoEnabled) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(_VideoPlayer_VideoPlayerAudiDescription__WEBPACK_IMPORTED_MODULE_31__["default"], {
      video: video
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(_VideoPlayer_VideoPlayer__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
      video: video
    });
  };

  var handleSwitchTabCallBack = function handleSwitchTabCallBack(data) {
    setCurrentSlideIndex(data);
    setActiveTabIndex(data);
    handleClickPageTab(data);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)(react__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
    children: [(doc == null ? void 0 : (_doc$fields8 = doc.fields) == null ? void 0 : _doc$fields8.corouselTitle) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("h2", {
      className: "carousel-heading ".concat((doc == null ? void 0 : (_doc$fields9 = doc.fields) == null ? void 0 : _doc$fields9.carouselHeadingClassname) ? doc == null ? void 0 : (_doc$fields10 = doc.fields) == null ? void 0 : _doc$fields10.carouselHeadingClassname : ''),
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(doc == null ? void 0 : (_doc$fields11 = doc.fields) == null ? void 0 : _doc$fields11.corouselTitle)
      }
    }), (doc == null ? void 0 : (_doc$fields12 = doc.fields) == null ? void 0 : _doc$fields12.carouselDescription) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
      className: "carousel-description ".concat(doc == null ? void 0 : (_doc$fields13 = doc.fields) == null ? void 0 : _doc$fields13.carouselDescriptionClassName),
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(doc == null ? void 0 : (_doc$fields14 = doc.fields) == null ? void 0 : _doc$fields14.carouselDescription)
      }
    }), doc == null ? void 0 : (_doc$fields15 = doc.fields) == null ? void 0 : (_doc$fields15$carouse = _doc$fields15.carouselItems) == null ? void 0 : _doc$fields15$carouse.map(function (item, index) {
      var _item$fields5;

      if ((item == null ? void 0 : (_item$fields5 = item.fields) == null ? void 0 : _item$fields5.tabItemShopNowCta) && index === activeTabIndex) {
        var _item$fields6;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(item == null ? void 0 : (_item$fields6 = item.fields) == null ? void 0 : _item$fields6.tabItemShopNowCta)
          },
          className: "ob-shop-now-wrapper"
        }, index);
      }
    }), (doc == null ? void 0 : (_doc$fields16 = doc.fields) == null ? void 0 : _doc$fields16.isCarouselTab) && (doc == null ? void 0 : (_doc$fields17 = doc.fields) == null ? void 0 : (_doc$fields17$carouse = _doc$fields17.carouselItems) == null ? void 0 : _doc$fields17$carouse.length) > 1 && !(isXSmall || isSmall) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
      className: "carousel-tabs ".concat((doc == null ? void 0 : (_doc$fields18 = doc.fields) == null ? void 0 : _doc$fields18.carouselTabItemsClassName) ? doc == null ? void 0 : (_doc$fields19 = doc.fields) == null ? void 0 : _doc$fields19.carouselTabItemsClassName : ''),
      children: tabItems
    }), (doc == null ? void 0 : (_doc$fields20 = doc.fields) == null ? void 0 : _doc$fields20.isCarouselPageTab) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
      className: "carouse-page-tabs-container",
      children: [(doc == null ? void 0 : (_doc$fields21 = doc.fields) == null ? void 0 : (_doc$fields21$leftArr = _doc$fields21.leftArrowPageTab) == null ? void 0 : (_doc$fields21$leftArr2 = _doc$fields21$leftArr.fields) == null ? void 0 : (_doc$fields21$leftArr3 = _doc$fields21$leftArr2.file) == null ? void 0 : _doc$fields21$leftArr3.url) && currentSlideIndex > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("button", {
        className: "carousel-page-left-button",
        onClick: function onClick() {
          return handleClickPageTabsScroll(currentSlideIndex - 1);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("img", {
          tabIndex: 0,
          src: (0,_adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_29__/* .optimizeImage */ .H)(doc == null ? void 0 : (_doc$fields22 = doc.fields) == null ? void 0 : (_doc$fields22$leftArr = _doc$fields22.leftArrowPageTab) == null ? void 0 : (_doc$fields22$leftArr2 = _doc$fields22$leftArr.fields) == null ? void 0 : (_doc$fields22$leftArr3 = _doc$fields22$leftArr2.file) == null ? void 0 : _doc$fields22$leftArr3.url),
          "data-action-detail": "carousel_panel",
          alt: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.leftArrow */ .NM.leftArrow
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
        tabIndex: 0,
        className: "carousel-page-tabs ".concat((doc == null ? void 0 : (_doc$fields23 = doc.fields) == null ? void 0 : _doc$fields23.carouselTabItemsClassName) ? doc == null ? void 0 : (_doc$fields24 = doc.fields) == null ? void 0 : _doc$fields24.carouselTabItemsClassName : ''),
        children: tabPageItems
      }), (doc == null ? void 0 : (_doc$fields25 = doc.fields) == null ? void 0 : (_doc$fields25$rightAr = _doc$fields25.rightArrowPageTab) == null ? void 0 : (_doc$fields25$rightAr2 = _doc$fields25$rightAr.fields) == null ? void 0 : (_doc$fields25$rightAr3 = _doc$fields25$rightAr2.file) == null ? void 0 : _doc$fields25$rightAr3.url) && currentSlideIndex < tabPageItems.length - 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("button", {
        className: "carousel-page-right-button",
        onClick: function onClick() {
          return handleClickPageTabsScroll(currentSlideIndex + 1);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("img", {
          tabIndex: 0,
          src: (0,_adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_29__/* .optimizeImage */ .H)(doc == null ? void 0 : (_doc$fields26 = doc.fields) == null ? void 0 : (_doc$fields26$rightAr = _doc$fields26.rightArrowPageTab) == null ? void 0 : (_doc$fields26$rightAr2 = _doc$fields26$rightAr.fields) == null ? void 0 : (_doc$fields26$rightAr3 = _doc$fields26$rightAr2.file) == null ? void 0 : _doc$fields26$rightAr3.url),
          "data-action-detail": "carousel_panel",
          alt: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.rightArrow */ .NM.rightArrow
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("section", {
      id: anchorId,
      ref: carouselRef,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, videoSettings), {}, {
        ref: sliderRef,
        className: doc == null ? void 0 : (_doc$fields27 = doc.fields) == null ? void 0 : _doc$fields27.className,
        afterChange: function afterChange(index) {
          return setCurrentSlideIndex(index);
        },
        children: doc == null ? void 0 : (_doc$fields28 = doc.fields) == null ? void 0 : (_doc$fields28$carouse = _doc$fields28.carouselItems) == null ? void 0 : _doc$fields28$carouse.map(function (item, index) {
          var _item$fields7, _item$fields8, _item$fields8$destina, _item$fields8$destina2, _item$fields9, _item$fields9$destina, _item$fields9$destina2, _item$fields10, _item$fields10$destin, _item$fields10$destin2, _item$fields11, _item$fields11$destin, _item$fields11$destin2, _item$fields12, _item$fields12$destin, _item$fields12$destin2, _item$fields13, _item$fields13$destin, _item$fields13$destin2, _item$fields14, _item$fields15, _item$fields16, _item$fields17, _item$fields18, _item$fields19, _item$fields20, _item$fields21, _item$fields22, _item$fields23, _item$fields23$carous, _item$fields24, _item$fields25, _item$fields26, _item$fields26$carous, _item$fields26$carous2, _item$fields27, _item$fields27$carous, _item$fields27$carous2, _item$fields28, _doc$fields29, _doc$fields29$carouse, _item$fields29, _item$fields30, _item$fields31, _item$fields32, _item$fields33, _item$fields34, _item$fields35, _item$fields36, _item$fields37, _item$fields38, _item$fields39, _item$fields40, _item$fields41, _item$fields42, _item$fields43, _item$fields44, _item$fields44$tabVid, _item$fields45, _item$fields45$produc, _item$fields45$produc2, _item$fields45$produc3, _productVariants$sele, _productVariants$sele2, _item$fields46, _item$fields47, _item$fields47$destin, _item$fields47$destin2, _item$fields48, _item$fields49, _item$fields51, _item$fields52, _item$fields53, _item$fields54, _item$fields54$button, _item$fields54$button2, _item$fields54$button3, _doc$fields30, _doc$fields31;

          switch (item == null ? void 0 : (_item$fields7 = item.fields) == null ? void 0 : _item$fields7.contentType) {
            case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.productCard */ .NM.productCard:
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("a", {
                href: item == null ? void 0 : (_item$fields8 = item.fields) == null ? void 0 : (_item$fields8$destina = _item$fields8.destinationUrl) == null ? void 0 : (_item$fields8$destina2 = _item$fields8$destina.fields) == null ? void 0 : _item$fields8$destina2.url,
                className: "card-link ".concat(item == null ? void 0 : (_item$fields9 = item.fields) == null ? void 0 : (_item$fields9$destina = _item$fields9.destinationUrl) == null ? void 0 : (_item$fields9$destina2 = _item$fields9$destina.fields) == null ? void 0 : _item$fields9$destina2.linkClassName),
                target: (item == null ? void 0 : (_item$fields10 = item.fields) == null ? void 0 : (_item$fields10$destin = _item$fields10.destinationUrl) == null ? void 0 : (_item$fields10$destin2 = _item$fields10$destin.fields) == null ? void 0 : _item$fields10$destin2.isExternalLink) ? "_blank" : null,
                rel: (item == null ? void 0 : (_item$fields11 = item.fields) == null ? void 0 : (_item$fields11$destin = _item$fields11.destinationUrl) == null ? void 0 : (_item$fields11$destin2 = _item$fields11$destin.fields) == null ? void 0 : _item$fields11$destin2.isExternalLink) && "noopener noreferrer",
                "data-action-detail": item == null ? void 0 : (_item$fields12 = item.fields) == null ? void 0 : (_item$fields12$destin = _item$fields12.destinationUrl) == null ? void 0 : (_item$fields12$destin2 = _item$fields12$destin.fields) == null ? void 0 : _item$fields12$destin2.dataActionDetail,
                "aria-label": item == null ? void 0 : (_item$fields13 = item.fields) == null ? void 0 : (_item$fields13$destin = _item$fields13.destinationUrl) == null ? void 0 : (_item$fields13$destin2 = _item$fields13$destin.fields) == null ? void 0 : _item$fields13$destin2.linkAriaLabel,
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                  className: "carousel-card",
                  children: [(item == null ? void 0 : (_item$fields14 = item.fields) == null ? void 0 : _item$fields14.productImage) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(Image, {
                    image: item == null ? void 0 : (_item$fields15 = item.fields) == null ? void 0 : _item$fields15.productImage
                  }), (item == null ? void 0 : (_item$fields16 = item.fields) == null ? void 0 : _item$fields16.productName) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("h2", {
                    className: "carousel-title",
                    children: [item == null ? void 0 : (_item$fields17 = item.fields) == null ? void 0 : _item$fields17.productName, " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(Icon, {
                      name: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.chevronRight */ .NM.chevronRight
                    })]
                  }), (item == null ? void 0 : (_item$fields18 = item.fields) == null ? void 0 : _item$fields18.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("h2", {
                    className: "carousel-heading",
                    children: item == null ? void 0 : (_item$fields19 = item.fields) == null ? void 0 : _item$fields19.title
                  }), (item == null ? void 0 : (_item$fields20 = item.fields) == null ? void 0 : _item$fields20.cta) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("h2", {
                    className: "carousel-cta",
                    children: item == null ? void 0 : (_item$fields21 = item.fields) == null ? void 0 : _item$fields21.cta
                  })]
                })
              }, index);

            case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.cloudinaryVideo */ .NM.cloudinaryVideo:
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                className: "carousel-video",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(_VideoPlayer_VideoPlayer__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
                  video: item == null ? void 0 : item.fields
                })
              });

            case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.carouselTabItem */ .NM.carouselTabItem:
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                className: "ob-carousel-tab-content-conatiner ".concat(item == null ? void 0 : (_item$fields22 = item.fields) == null ? void 0 : _item$fields22.carouselTabItemClassName),
                children: [(item == null ? void 0 : (_item$fields23 = item.fields) == null ? void 0 : (_item$fields23$carous = _item$fields23.carouselTabInnerItem) == null ? void 0 : _item$fields23$carous.length) > 0 && (item == null ? void 0 : (_item$fields24 = item.fields) == null ? void 0 : _item$fields24.carouselTabInnerItem.map(function (res, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(react__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
                    children: new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z(res).renderBlockFromDocument(res)
                  }, index);
                })), (item == null ? void 0 : (_item$fields25 = item.fields) == null ? void 0 : _item$fields25.carouselHtmlSection) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                  className: item == null ? void 0 : (_item$fields26 = item.fields) == null ? void 0 : (_item$fields26$carous = _item$fields26.carouselHtmlSection) == null ? void 0 : (_item$fields26$carous2 = _item$fields26$carous.fields) == null ? void 0 : _item$fields26$carous2.classNames,
                  dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(item == null ? void 0 : (_item$fields27 = item.fields) == null ? void 0 : (_item$fields27$carous = _item$fields27.carouselHtmlSection) == null ? void 0 : (_item$fields27$carous2 = _item$fields27$carous.fields) == null ? void 0 : _item$fields27$carous2.text)
                  }
                }), (isMedium || isXSmall || isSmall) && (item == null ? void 0 : (_item$fields28 = item.fields) == null ? void 0 : _item$fields28.tabTitle) && (doc == null ? void 0 : (_doc$fields29 = doc.fields) == null ? void 0 : (_doc$fields29$carouse = _doc$fields29.carouselItems) == null ? void 0 : _doc$fields29$carouse.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                  className: 'carousel-tabs-mobile',
                  children: [item == null ? void 0 : (_item$fields29 = item.fields) == null ? void 0 : _item$fields29.tabTitle, " "]
                }), (item == null ? void 0 : (_item$fields30 = item.fields) == null ? void 0 : _item$fields30.tabItemDetailVideo) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                  children: [new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z(item == null ? void 0 : (_item$fields31 = item.fields) == null ? void 0 : _item$fields31.tabItemDetailVideo).renderBlockFromDocument(item == null ? void 0 : (_item$fields32 = item.fields) == null ? void 0 : _item$fields32.tabItemDetailVideo), " "]
                }) : (item == null ? void 0 : (_item$fields33 = item.fields) == null ? void 0 : _item$fields33.tabImage) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                  className: "ob-carousel-tab-content-conatiner-image",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(ResponsiveImage, {
                    document: item == null ? void 0 : (_item$fields34 = item.fields) == null ? void 0 : _item$fields34.tabImage
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                  className: "ob-carousel-tab-content-conatiner-desc-wrapper",
                  children: [(item == null ? void 0 : (_item$fields35 = item.fields) == null ? void 0 : _item$fields35.tabDescription) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                      __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(item == null ? void 0 : (_item$fields36 = item.fields) == null ? void 0 : _item$fields36.tabDescription)
                    }
                  }), (item == null ? void 0 : (_item$fields37 = item.fields) == null ? void 0 : _item$fields37.tabVideoTitle) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("button", {
                    className: "carousel-tab-video-cta carousel-tab-video-cta-".concat(index),
                    onClick: function onClick(e) {
                      return openModal(e);
                    },
                    children: item == null ? void 0 : (_item$fields38 = item.fields) == null ? void 0 : _item$fields38.tabVideoTitle
                  }), (item == null ? void 0 : (_item$fields39 = item.fields) == null ? void 0 : _item$fields39.tabLinkNextDescription) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("span", {
                    dangerouslySetInnerHTML: {
                      __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(item == null ? void 0 : (_item$fields40 = item.fields) == null ? void 0 : _item$fields40.tabLinkNextDescription)
                    }
                  })]
                }), (item == null ? void 0 : (_item$fields41 = item.fields) == null ? void 0 : _item$fields41.tabItemLearnMoreCta) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                  dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(item == null ? void 0 : (_item$fields42 = item.fields) == null ? void 0 : _item$fields42.tabItemLearnMoreCta)
                  },
                  className: "ob-learn-More-cta-wrapper"
                }), isModalOpen && (item == null ? void 0 : (_item$fields43 = item.fields) == null ? void 0 : _item$fields43.tabVideo) && index === activeTabIndex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_24___default()), {
                  isOpen: isModalOpen,
                  onRequestClose: closeModal,
                  style: customStyles,
                  htmlOpenClassName: 'ob-carousel-tab-item-video',
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                    className: 'ob-carousel-tab-item-video-container',
                    children: renderVideo(item == null ? void 0 : (_item$fields44 = item.fields) == null ? void 0 : (_item$fields44$tabVid = _item$fields44.tabVideo) == null ? void 0 : _item$fields44$tabVid.fields)
                  })
                })]
              }, index);

            case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.articleProductCard */ .NM.articleProductCard:
              var productVariants = item == null ? void 0 : (_item$fields45 = item.fields) == null ? void 0 : (_item$fields45$produc = _item$fields45.product) == null ? void 0 : (_item$fields45$produc2 = _item$fields45$produc[0]) == null ? void 0 : (_item$fields45$produc3 = _item$fields45$produc2.fields) == null ? void 0 : _item$fields45$produc3.productVariants;
              var productVariantImage = productVariants == null ? void 0 : (_productVariants$sele = productVariants[selectedVariants == null ? void 0 : selectedVariants[index]]) == null ? void 0 : (_productVariants$sele2 = _productVariants$sele.fields) == null ? void 0 : _productVariants$sele2.productGridAsset;
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                className: "carousel-article-card",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                  className: "ob-bg-image-container",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(Image, {
                    image: item == null ? void 0 : (_item$fields46 = item.fields) == null ? void 0 : _item$fields46.backgroundImage,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                      className: "article-items-wrapper",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                        className: "ob-image-container",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(Image, {
                          image: productVariantImage
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                        className: "text-variant-selector-container",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("h3", {
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("a", {
                            href: item == null ? void 0 : (_item$fields47 = item.fields) == null ? void 0 : (_item$fields47$destin = _item$fields47.destinationUrl) == null ? void 0 : (_item$fields47$destin2 = _item$fields47$destin.fields) == null ? void 0 : _item$fields47$destin2.url,
                            className: "card-link",
                            children: item == null ? void 0 : (_item$fields48 = item.fields) == null ? void 0 : _item$fields48.title
                          }, index)
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("p", {
                          children: item == null ? void 0 : (_item$fields49 = item.fields) == null ? void 0 : _item$fields49.description
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                          className: "ob-color-variant-button-container",
                          children: productVariants.map(function (variant, i) {
                            var _variant$fields;

                            var color = variant == null ? void 0 : (_variant$fields = variant.fields) == null ? void 0 : _variant$fields.color;

                            if (!color) {
                              return null;
                            } else {
                              var _color$fields, _color$fields2, _color$fields3, _item$fields50, _color$fields4, _color$fields5, _color$fields5$colorI, _color$fields5$colorI2, _color$fields6, _color$fields6$colorI, _color$fields6$colorI2, _color$fields6$colorI3;

                              return !(color == null ? void 0 : (_color$fields = color.fields) == null ? void 0 : _color$fields.colorImage) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("button", {
                                "aria-label": color == null ? void 0 : (_color$fields2 = color.fields) == null ? void 0 : _color$fields2.name,
                                type: _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .Constants.button */ .gT.button,
                                className: classnames__WEBPACK_IMPORTED_MODULE_22___default()("ob-series__color ob-series__color--large-mobile event_buy_now_choose_product", _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_7___default()({}, "ob-series__color--active", i === selectedVariants[index])),
                                style: (0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_28__/* .getColorStyle */ .Nt)(color),
                                "data-action-detail": "".concat(color == null ? void 0 : (_color$fields3 = color.fields) == null ? void 0 : _color$fields3.name, "_").concat((0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_28__/* .stripHtml */ .Vt)(item == null ? void 0 : (_item$fields50 = item.fields) == null ? void 0 : _item$fields50.title)),
                                onClick: function onClick() {
                                  var newSelectedVariants = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6___default()(selectedVariants);

                                  newSelectedVariants[index] = i;
                                  setSelectedVariants(newSelectedVariants);
                                },
                                "aria-pressed": i === selectedVariants[index],
                                children: color == null ? void 0 : (_color$fields4 = color.fields) == null ? void 0 : _color$fields4.name
                              }, i) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("img", {
                                className: "event_buy_now_choose_product ob-series-product-color-img ".concat(i === selectedVariants[index] ? "ob-series__color--active" : ""),
                                "data-action-detail": "".concat(color == null ? void 0 : color.fields.name, "_").concat((0,_adapters_helpers_Utils__WEBPACK_IMPORTED_MODULE_28__/* .stripHtml */ .Vt)(title)),
                                alt: color == null ? void 0 : (_color$fields5 = color.fields) == null ? void 0 : (_color$fields5$colorI = _color$fields5.colorImage) == null ? void 0 : (_color$fields5$colorI2 = _color$fields5$colorI.fields) == null ? void 0 : _color$fields5$colorI2.title,
                                src: color == null ? void 0 : (_color$fields6 = color.fields) == null ? void 0 : (_color$fields6$colorI = _color$fields6.colorImage) == null ? void 0 : (_color$fields6$colorI2 = _color$fields6$colorI.fields) == null ? void 0 : (_color$fields6$colorI3 = _color$fields6$colorI2.file) == null ? void 0 : _color$fields6$colorI3.url,
                                onClick: function onClick() {
                                  var newSelectedVariants = _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_6___default()(selectedVariants);

                                  newSelectedVariants[index] = i;
                                  setSelectedVariants(newSelectedVariants);
                                }
                              }, i);
                            }
                          })
                        })]
                      })]
                    })
                  })
                })
              });

            case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.htmlBlock */ .NM.htmlBlock:
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.Fragment, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                  className: item == null ? void 0 : (_item$fields51 = item.fields) == null ? void 0 : _item$fields51.classNames,
                  dangerouslySetInnerHTML: {
                    __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(item == null ? void 0 : (_item$fields52 = item.fields) == null ? void 0 : _item$fields52.text)
                  }
                }), isModalOpen && (item == null ? void 0 : (_item$fields53 = item.fields) == null ? void 0 : _item$fields53.buttonVideoBlock) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_24___default()), {
                  isOpen: isModalOpen,
                  onRequestClose: closeModal,
                  style: customStyles,
                  htmlOpenClassName: 'ob-html-video-button-wrapper',
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                    className: 'ob-html-video-container',
                    children: renderVideo(item == null ? void 0 : (_item$fields54 = item.fields) == null ? void 0 : (_item$fields54$button = _item$fields54.buttonVideoBlock) == null ? void 0 : (_item$fields54$button2 = _item$fields54$button.fields) == null ? void 0 : (_item$fields54$button3 = _item$fields54$button2.video) == null ? void 0 : _item$fields54$button3.fields)
                  })
                })]
              });

            case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.contentBlock */ .NM.contentBlock:
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                children: [new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z(doc == null ? void 0 : (_doc$fields30 = doc.fields) == null ? void 0 : _doc$fields30.carouselItems).renderSpecifiedBlock(doc == null ? void 0 : (_doc$fields31 = doc.fields) == null ? void 0 : _doc$fields31.carouselItems), " "]
              });

            case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.miniContentBlock */ .NM.miniContentBlock:
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsxs)("div", {
                children: [new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z(item).renderBlockFromDocument(item), " "]
              });

            case _adapters_helpers_Constants__WEBPACK_IMPORTED_MODULE_26__/* .CarouselBlockConstants.RowLayoutCard */ .NM.RowLayoutCard:
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
                children: new _adapters_helpers_Block__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z(item).renderBlockFromDocument()
              });

            default:
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(Image, {
                image: item
              });
          }
        })
      }))
    }), (doc == null ? void 0 : (_doc$fields32 = doc.fields) == null ? void 0 : _doc$fields32.carouselCta) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
      className: "carousel-cta-container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("div", {
        "class": "cta-wrapper",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("a", {
          href: doc == null ? void 0 : (_doc$fields33 = doc.fields) == null ? void 0 : (_doc$fields33$carouse = _doc$fields33.carouselCta) == null ? void 0 : (_doc$fields33$carouse2 = _doc$fields33$carouse.fields) == null ? void 0 : _doc$fields33$carouse2.ctaUrl,
          target: (doc == null ? void 0 : (_doc$fields34 = doc.fields) == null ? void 0 : (_doc$fields34$carouse = _doc$fields34.carouselCta) == null ? void 0 : (_doc$fields34$carouse2 = _doc$fields34$carouse.fields) == null ? void 0 : _doc$fields34$carouse2.externalLink) ? "_blank" : "",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("span", {
            children: doc == null ? void 0 : (_doc$fields35 = doc.fields) == null ? void 0 : (_doc$fields35$carouse = _doc$fields35.carouselCta) == null ? void 0 : (_doc$fields35$carouse2 = _doc$fields35$carouse.fields) == null ? void 0 : _doc$fields35$carouse2.ctaName
          })
        })
      })
    }), (doc == null ? void 0 : (_doc$fields36 = doc.fields) == null ? void 0 : _doc$fields36.switchTabs) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)(SwitchTab, {
      document: doc.fields.switchTabs,
      changeTabIndex: currentSlideIndex,
      handleSwitchTabCallBack: handleSwitchTabCallBack,
      carouselSwitchTab: true,
      carouselProp: props
    }), (doc == null ? void 0 : (_doc$fields37 = doc.fields) == null ? void 0 : _doc$fields37.imageBelowText) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_33__.jsx)("p", {
      className: "carousel-image-below-text",
      dangerouslySetInnerHTML: {
        __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_32___default().sanitize(doc == null ? void 0 : (_doc$fields38 = doc.fields) == null ? void 0 : _doc$fields38.imageBelowText)
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = ((0,_adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_25__/* .mediaQueryHOC */ .Ui)(CarouselBlock));

/***/ })

}]);